import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.76 14.236v6.982c0 2.593 18.343 17.455 18.343 17.455v14.963L38.017 59V38.673S57.12 23.81 57.12 21.218v-6.982c0-2.592-.09-1.142-.026-3.58l-48.407-.062c-.03.906.094 1 .072 3.642z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 21c0 2.47 18.69 17.63 18.69 17.63v14.26L36.62 57V38.63S56 23.47 56 21H10z",
      fill: "#86bc4d"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11 13h44",
      stroke: "#1e3951",
      "stroke-width": "2",
      fill: "none"
    }, null, -1)
  ])))
}
export default { render: render }